__turbopack_context__.v({
  "urgent-label": "ProductUrgentMessageLabel-module-scss-module__AWLHXG__urgent-label",
});
